import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, useToast } from "@chakra-ui/react";
import Form from "@rjsf/chakra-ui";
import validator from "@rjsf/validator-ajv8";
import { reverseTransformData, transformData } from "../../../util/helper";
import {
  getThemePrefaceData,
  updateThemePrefaceData,
} from "../../../services/Theme";
import CKEditorWidget from "../../../CommonComponents/CKEditorWidget";
import { RjsfSubmitButton } from "../../../RJSFCommonSchemas";
import FormLoader from "../../../CommonComponents/FormLoader";
import { showErrorToast, showSuccessToast } from "../../../util/errorHandler";

const Preface = () => {
  const { alias } = useParams();
  // const [basicFieldData, setBasicFieldData] = useState({});
  const [processedData, setProcessedData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [quickSave, setQuickSave] = useState(false);
  const toast = useToast();

  const schema = {
    title: "Theme Preface fields",
    description: "",
    type: "object",
    properties: {
      description: {
        type: "string",
        title: "Preface",
      },
    },
  };

  const uiSchema = {
    ...RjsfSubmitButton(isSubmitting),
    description: {
      "ui:widget": CKEditorWidget,
      "ui:options": {
        placeholder: "Enter preface content...",
        height: "400px",
      },
    },
  };

  const formData = processedData;

  // Fetch initial data
  useEffect(() => {
    const getPrefaceData = async () => {
      try {
        if (alias) {
          const result = await getThemePrefaceData(alias);
          if (result) {
            const fieldsToTransform = [
              "poster_image_carousel_alias",
              "other_publicity_image_carousel_alias",
            ];

            setProcessedData(transformData(result, fieldsToTransform));
          }
        }
      } catch (error) {
        console.error("Error fetching film data:", error);
        showErrorToast(toast, "Failed to fetch film data");
      } finally {
        setIsLoading(false);
      }
    };

    getPrefaceData();
  }, [alias, toast, quickSave]);

  // Submit updated data
  const handleSubmit = async (formData) => {
    const fieldsToTransform = [
      "poster_image_carousel_alias",
      "other_publicity_image_carousel_alias",
    ];

    const updatedFormData = reverseTransformData(formData, fieldsToTransform);
    // setIsSubmitting(true);

    try {
      if (alias) {
        setIsSubmitting(true);
        const result = await updateThemePrefaceData(alias, updatedFormData, {});

        if (result?.status === 200) {
          setQuickSave((prev) => !prev);
          showSuccessToast(toast, "Data updated successfully");
        }
      }
    } catch (error) {
      console.error("Error updating film data:", error);
      showErrorToast(toast, "Failed to update film data");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box maxW="auto">
      {isLoading ? (
        <FormLoader />
      ) : (
        <Form
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          validator={validator}
          onSubmit={(e) => handleSubmit(e.formData)}
        />
      )}
    </Box>
  );
};

export default Preface;
